const subscriber = JSON.parse(localStorage.getItem('subscriber'));

const tableProduct = () => {
    return {
        loading: false,
        data: [],
        fields: [
            {
                name: 'Codigo',
                field: 'code',
                width: 100
            },
            {
                field: 'description',
                name: 'Descripcion',
                width: 550
            },
            {
                field: 'brand.description',
                name: 'Marca',
                width: 100
            },
            {
                field: 'line.line_description',
                name: 'Linea',
                width: 150
            },
            {
                field: 'subline.subline_description',
                name: 'SubLinea',
                width: 150
            },
            {
                field: 'stock',
                name: 'Exist',
                width: 150
            },
            {
                field: 'available',
                name: 'Dispon',
                width: 150,
                visible: !subscriber || !subscriber.company_type_parameter || subscriber.company_type_parameter.code_parameter !== '03'
            },
            {
                field: 'state',
                name: 'Estado',
                width: 150
            },
            {
                field: 'update_wsm_tag',
                name: 'Estado WMS',
                width: 100,
                visible: !!subscriber && !!subscriber.wms_json_auth && !!subscriber.wms_json_auth.url
            },
            {
                field: 'actions',
                name: 'Opciones',
                width: 200
            }
        ],
        errors: {
            has: false,
            message: '',
            code: 0,
            data: []
        },
        pagination: [],
        options: {
            perPage: 100,
            search: '',
            currentPage: 1,
            page: 1,
            filter_lines: [],
            filter_sublines: [],
            electronic_bill: 1,
            filter_brands: [],
            filter_subbrands: [],
            states: [1],
            only_combos: 0,
            branch_office_id: null,
            branch_office_warehouse_id: null,
            update_wsm: false,
        }
    }
};

const params = () => {
    return {
        category_id: '',
        paginate: false,
        product: '',
        branchoffice_warehouse_id: '',
        branchoffice: null,
        filter: '',
        electronic_bill: 1,
        page: 1,
        perPage: 15,
        manager_wms: !!subscriber && !!subscriber.manager_wms ? subscriber.manager_wms : 0,
    }
}

export const defaultSelectedProduct = () => {
    return {
        manage_inventory: true,
        manage_expire_date: false,
        combo: false,
        buy_block: false,
        inevitable: false,
        consignment: false,
        provider: '',
        code: '',
        barcode: '',
        description: '',
        line_id: '',
        subline_id: '',
        brand_id: '',
        subbrand_id: '',
        category_id: '',
        b2c_description: '',
        owner: '',
        maker: '',
        update_wsm_tag: '',
        subcategory_id: '',
        subcategory_id_1: '',
        url_producer: '',
        inventory_management: '',
        purchase: '',
        sale: '',
        kit: '',
        state: 1,
        condition: '',
        has_lot: 0,
        has_serial: 0,
        type: '',
        high_price: 0,
        products_risk_id: '',
        rotation_type: '',
        cooled: 0,
        reusable: '',
        production_formula: '',
        tariff_position: '',
        export_product: '',
        conformity_certificate: '',
        exp_date_certified: '',
        pos: 0,
        lock_buy: '',
        lock_buy_observations: '',
        lock_sale: '',
        lock_sale_observations: '',
        percentage_iva_buy: null,
        percentage_tax_consumer_buy: '',
        percentage_iva_sale: null,
        percentage_tax_consumer_sale: '',
        balance_units: '',
        balance_value: '',
        average_cost: '',
        start_date_inventory: '',
        modify_description_buy: '',
        modify_price_buy: '',
        observation_buy: '',
        presentation_packaging_buy: '',
        presentation_quantity_buy: '',
        presentation_unit_buy: '',
        presentation_assembled_buy: '',
        minimum_quantity_buy: '',
        local_buy: 0,
        calculate_price_buy: '',
        automatic_reposition: '',
        contact_id: '',
        point_of_sale_deployment: 0,
        amazon_deployment: 0,
        free_market_deployment: '',
        modify_description_sale: '',
        modify_price: false,
        modify_price_sale: '',
        observation_sale: '',
        allow_invoices_sales_zeros: '',
        presentation_packaging_sale: '',
        presentation_quantity_sale: '',
        presentation_unit_sale: '',
        presentation_assembled_sale: '',
        minimum_quantity_sale: '',
        commision_percentage: '',
        profit_margin_percentage: '',
        entry_third_party: '',
        controlled_sale: 0,
        product_of_continuous_use: '',
        quantity_available: '',
        long_description: '',
        erp_id: '',
        cost_center: '',
        old_product_code: '',
        reduction_management: 0,
        high_risk: 0,
        channel_b2c: 0,
        channel_b2b: 0,
        block_buy: 0,
        block_sale: 0,
        products_technnical_data: {
            link_manufacturer_one: '',
            link_manufacturer_two: '',
            weight: '',
            volume: '',
            size: '',
            color: '',
            year_model: '',
            series: '',
            link_data_sheet: '',
            data_sheet: 0,
            products_technical_datacol: '',
            link_video: '',
            generic: 0,
            used: '',
            invima_registry: '',
            expiration_date_invima: '',
            width: '',
            profile: '',
            rin: '',
            load_index: '',
            velocity_index: '',
            utqg: '',
            runflat: '',
            lt: '',
            code_cum: '',
            code_secretary_of_health: '',
            aplication_unit: '',
            number_aplications: '',
            pharmacological_indication_code: '',
            concentration: '',
            pharmaceutical_form: '',
            form_unit: '',
            number_of_doses: '',
            ium_cod: '',
            exclude_sales_report: null
        },
        products_attachments: {
            url: ''
        },
        products_combo: [],
        discount_percentage: 0,
        informative_discount_percentage: 0,
        product_type_id: null,
        generic_product_id: null,
        maximum_discount_percentage: null,
        inventory:null,
        supplyer_code:'',
        detailed_description: '',
        manage_lot:false,
        sale_type: '',
        percentage_consumption_tax: null,
        value_consumption_tax: null,
        previous_code_system: '',
        short_description: '',
        rotation_classification: '',
        packing_unit: null,
        id: null,
        ultra_processed_tax_percentage: 0,
        value_sugary_drinks:null,
    };
};

const loadImages = {
    loader: '',
    totalCuantity: 0,
    loadedQuantity: 0,
    processedQuantity: 0,
    images: [],
    errors: {
        has: false,
        message: [],
        data: []
    }
}

export const product_combo = () => {
    return {
        product_id: null,
        quantity: null
    }
}

export default {
    parameters_status: [],
    providers: [],
    products: [],
    lines: [],
    rotationclassification: [],
    sublines: [],
    brands: [],
    subbrands: [],
    groups: [],
    contacts: [],
    categories: [],
    subcategories: [],
    productType: [],
    size: [],
    color: [],
    rotationType: [],
    applicationUnit: [],
    codes: [],
    productEdit: null,
    showData: false,
    showCreateNewProduct: false,
    selectedProduct: defaultSelectedProduct(),
    price_lists: [],
    price: {
      price_list_id: null,
      price: 0,
      product_id: null
    },
    types: [],
    generic_products: [],
    selectedClassification: [],
    products_attachments: [],
    error: false,
    errorMessage: '',
    action: 'create',
    params: params(),
    line_param: {
        line: ''
    },
    search_params: {
        branch: ''
    },
    errorFileImport: '',
    loadFileImport: false,
    data_sheets: [],
    // By: Kevin Galindo
    tableProduct: tableProduct(),
    packing_units: [],
    loadImages,
    preloader: false,
    products_combo: [],
    product_combo: product_combo(),
    modal_combos: {
        show: false
    },
    branchsWare:[],
    inventory: {
        branchoffice_warehouse_id : Number(localStorage.getItem("selected_branchoffice_warehouse")),
        product_id :null,
        minimum_stock :'',
        maximum_stock :'',
        location :'',
    },
    parameter_rotation_classification: [],
    data_sheets_from_b2b : false,
    subscriber : null,
    auditProduct: [],
    vehicleBrands: [],
    vehicleModels: [],
    vehicleYears: [],
    vehicleEngineDisplacements: [],
    vehicleTransmissions: [],
    inheritVehiclesProducts: [],
    productInheritVehiclesList: [],
    productVehicles: []
};



// WEBPACK FOOTER //
// ./src/modules/products/state.js